import { ActionType } from '@enums/node-types.enum';
import { NodeVisualStrategy } from './NodeVisualStrategy';
import { NormalNodeStrategy } from './NormalNodeStrategy';
import { RewardNodeStrategy } from './RewardNodeStrategy';
import { CheckpointNodeStrategy } from './CheckpointNodeStrategy';
import { FinishNodeStrategy } from './FinishNodeStrategy';

// Singleton instances - strategies are stateless, so we can reuse them
const normalStrategy = new NormalNodeStrategy();
const rewardStrategy = new RewardNodeStrategy();
const checkpointStrategy = new CheckpointNodeStrategy();
const finishStrategy = new FinishNodeStrategy();

const strategyMap: Record<ActionType, NodeVisualStrategy> = {
  [ActionType.Normal]: normalStrategy,
  [ActionType.Prize]: rewardStrategy,
  [ActionType.Checkpoint]: checkpointStrategy,
  [ActionType.Finish]: finishStrategy,
  [ActionType.MoveBack]: rewardStrategy,
  [ActionType.MoveForward]: rewardStrategy,
  [ActionType.SkipTurn]: rewardStrategy,
  [ActionType.Collectible]: rewardStrategy,
  [ActionType.ExtraRoll]: rewardStrategy,
};

/**
 * Returns the appropriate NodeVisualStrategy for the given node type.
 * Falls back to NormalNodeStrategy for unknown types.
 */
export function getStrategy(type: ActionType): NodeVisualStrategy {
  return strategyMap[type] ?? normalStrategy;
}
